__webpack_require__.p = "https://certificate.quantstamp.com/full/taler/dfa77a39-d190-49f6-b57b-48d073f0c8a0/";